import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

import { IoNewspaperOutline } from 'react-icons/io5'
import { setSelectedApp } from '../../../../redux/Slices/Global/globalSlice';
import white3DIcon from "../../../../assets/img/3d_white.png"
import MediaList from '../../../Apps/Multi3dViewer/MediaList';
import RssList from './RssList';

import { Message } from 'primereact/message';
import { Image } from 'react-bootstrap';
import WeatherList from './WeatherList';
import ClockList from './ClockList';

function Apps() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { selectedApp, layer, companyDetails } = useSelector((state) => state.global);
    const { pathname } = window.location;
    const showRSS = pathname.includes("campaign") || pathname.includes("playlist") ? (layer === "BANNER" || layer === "PLAYGROUND") : pathname.includes("layout");
    const showWeather = pathname.includes("campaign") || pathname.includes("playlist") ? layer === "MAIN" || layer === "PLAYGROUND" || layer === "CORNER" : pathname.includes("layout");


    const apps = [
        {
            featureKey: "rss_feed",
            title: t('addcontent.app_rss_feeds'),
            icon: <i className="fa-solid fa-rss fs-3"></i>,
            visible: companyDetails?.package?.features?.["rss_feed"] && showRSS,

        },
        {
            featureKey: "banner",
            title: t('addcontent.app_custom_rss'),
            icon: <IoNewspaperOutline className='fs-3' />,
            visible: companyDetails?.package?.features?.["rss_feed"] && showRSS,

        },
        {
            featureKey: "3d",
            title: t('addcontent.app_multi3d'),
            icon: <Image src={white3DIcon} width="30" />,
            visible: companyDetails?.package?.features?.["3d"] && layer == "MAIN",
        },
        {
            featureKey: "weather",
            title: t('addcontent.app_weather'),
            icon: <i className="fa-solid fa-cloud-sun fs-3"></i>,
            visible: companyDetails?.package?.features?.["weather"] && showWeather,

        }
        ,
        {
            featureKey: "clock",
            title: t('addcontent.app_clock'),
            icon: <i className="fa-solid fa-clock fs-3"></i>,
            visible: companyDetails?.package?.features?.["clock"] && showWeather,

        },
    ]

    const allVisibleFalse = apps.every(obj => obj.visible === false);

    const components = {
        rss_feed: <RssList />,
        weather: <WeatherList />,
        clock: <ClockList />,


        banner: <RssList mediaType={"RSS_CUSTOM"} />,
        "3d": <MediaList path={"/media/multi_3d"} />,
    }



    return (allVisibleFalse) ?
        <div className='w-100 flex justify-center items-center h-full'>
            <Message className="fw-bold fs-3 p-4 w-75 mt-5" severity="warn" text={t('addcontent.no_compatible_apps')} />
        </div>
        :
        isEmpty(selectedApp) ?
            apps.map((app, index) => {
                return app?.visible ? (
                    <div className={`co1-12 d-flex  align-items-center text-dark  bg-label-secondary px-3 py-2 cursor-pointer ${index + 1 == apps.length ? "" : "border-bottom"}`}
                        onClick={() => { dispatch(setSelectedApp({ title: app?.title, featureKey: app?.featureKey })) }}
                        key={`${Math.random(20)}`}>
                        <div className='col-1 p-3 bg-dark text-white me-2 rounded-3 flex justify-center items-center'  >{app?.icon}</div>
                        <div className="fw-bold">{app?.title}</div>
                    </div>
                )
                    :
                    <></>
            })
            :
            components?.[selectedApp?.featureKey]
}

export default Apps